/* tslint:disable */
import { Injectable, Inject, Optional } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { SDKModels } from './SDKModels';
import { BaseLoopBackApi } from '../core/base.service';
import { LoopBackConfig } from '../../lb.config';
import { LoopBackAuth } from '../core/auth.service';
import { LoopBackFilter,  } from '../../models/BaseModels';
import { ErrorHandler } from '../core/error.service';
import { Observable, Subject } from 'rxjs';
// import { map } from 'rxjs/operators';
import { PaymentService } from '../../models/PaymentService';
import { Http, Response } from '@angular/http';
import { JSONSearchParams } from '../core/search.params';
import { SocketConnection } from '../../sockets/socket.connections';


/**
 * Api services for the `PaymentService` model.
 */
@Injectable()
export class PaymentServiceApi extends BaseLoopBackApi {

  // constructor(
  //   @Inject(HttpClient) protected http: HttpClient,
  //   @Inject(SocketConnection) protected connection: SocketConnection,
  //   @Inject(SDKModels) protected models: SDKModels,
  //   @Inject(LoopBackAuth) protected auth: LoopBackAuth,
  //   @Optional() @Inject(ErrorHandler) protected errorHandler: ErrorHandler
  // ) {
  //   super(http,  connection,  models, auth, errorHandler);
  // }
  constructor(
    @Inject(Http) protected http: Http,
    @Inject(SocketConnection) protected connection: SocketConnection,
    @Inject(SDKModels) protected models: SDKModels,
    @Inject(LoopBackAuth) protected auth: LoopBackAuth,
    @Inject(JSONSearchParams) protected searchParams: JSONSearchParams,
    @Optional() @Inject(ErrorHandler) protected errorHandler: ErrorHandler
  ) {
    super(http,  connection,  models, auth, searchParams, errorHandler);
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} data Request data.
   *
   * This method expects a subset of model properties as request parameters.
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `PaymentService` object.)
   * </em>
   */
  public getPaymentChannel(params: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/PaymentServices/getPaymentChannel";
    let _routeParams: any = {};
    let _postBody: any = {
      params: params
    };
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} data Request data.
   *
   * This method expects a subset of model properties as request parameters.
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `PaymentService` object.)
   * </em>
   */
  public updateParentTransaction(params: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/PaymentServices/updateParentTransaction";
    let _routeParams: any = {};
    let _postBody: any = {
      params: params
    };
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `PaymentService`.
   */
  public getModelName() {
    return "PaymentService";
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/services/custom/PaymentService.ts